import { DataProvider } from 'react-admin';
import { usersDataProvider } from './usersDataProvider';
import { eventsDataProvider } from './eventsDataProvider';
import { eventReportsProvider } from './eventReportsProvider';
import { categoriesDataProvider } from './categoriesDataProvider';

const getProvider = (resource: string): DataProvider => {
  console.log('getProvider', { resource });

  if (resource === '/users') {
    return usersDataProvider;
  }

  if (resource === '/events') {
    return eventsDataProvider;
  }

  if (resource === '/reports') {
    return eventReportsProvider
  }

  if (resource === '/categories') {
    return categoriesDataProvider;
  }

  throw new Error(
    `Requests for resource ${resource} have not been implemented`,
  );
};

export const dataProvider: DataProvider = {
  // get a list of records based on sort, filter, and pagination
  getList: async (resource, params) => {
    const provider = getProvider(resource);
    return provider.getList(resource, params);
  },
  getOne: async (resource, params) => {
    const provider = getProvider(resource);
    return provider.getOne(resource, params);
  },
  // get a list of records based on an array of ids
  getMany: async (resource, params) => {
    const provider = getProvider(resource);
    return provider.getMany(resource, params);
  },
  // get the records referenced to another record, e.g. comments for a post
  getManyReference: (resource, params) => {
    const provider = getProvider(resource);
    return provider.getManyReference(resource, params);
  },
  // create a record
  // // @ts-expect-error not typed
  create: (resource, params) => {
    const provider = getProvider(resource);
    return provider.create(resource, params);
    // return Promise.resolve({ data: { id: 'test', la: 'la' } });
  },
  // update a record based on a patch
  update: (resource, params) => {
    const provider = getProvider(resource);
    return provider.update(resource, params);
  },
  // update a list of records based on an array of ids and a common patch
  updateMany: (resource, params) => {
    return Promise.resolve({ data: [] });
  },
  // delete a record by id
  delete: (resource, params) => {
    const provider = getProvider(resource);
    return provider.delete(resource, params);
  },
  // delete a list of records based on an array of ids
  deleteMany: (resource, params) => {
    const provider = getProvider(resource);
    return provider.deleteMany(resource, params);
  },
};
